import { Record, Set as ImmutableSet } from 'immutable';
// @ts-expect-error FIXME: No module
import EmailAddressRecord from 'customer-data-email/schema/email/EmailAddressRecord';
const Recipient = Record({
  to: new EmailAddressRecord(),
  emailAddresses: ImmutableSet()
}, 'Recipient');
export default Recipient;